<span>{{ 'Query::IndexingCompletedNotification' | abpLocalization: queryName }}</span>
